import { render, staticRenderFns } from "./AppointmentAdd.vue?vue&type=template&id=08c33014&scoped=true"
import script from "./AppointmentAdd.vue?vue&type=script&lang=js"
export * from "./AppointmentAdd.vue?vue&type=script&lang=js"
import style0 from "./AppointmentAdd.vue?vue&type=style&index=0&id=08c33014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c33014",
  null
  
)

export default component.exports